module.exports = __webpack_public_path__ + "static/marie-claire-0b526a26637df55c1cd529e7d07d4c1e.svg";